React = require 'react'
t = require('views/internal/recup-with-helpers')('org_filtering')

sortOptions =
  alphabetical: 'Alphabetical'
  active: 'Most Active'
  members: 'Number of Members'
  stars: 'Number of Stars'

renderList = (items, title, { hasCloseableItems, onAddTag } = {}) ->
  t.ul '.boards-page-navigation-list', ->
    t.li '.boards-page-navigation-list-header', ->
      t.text title

    for { html, selected, onClick } in items
      t.li '.boards-page-navigation-list-item', ->
        classes =
          'boards-page-navigation-list-item-link': true
          'mod-closeable': hasCloseableItems
          'is-active': selected
        t.b onClick, class: t.classify(classes), ->
          t.raw html
          if hasCloseableItems && selected
            t.icon "close", class: "boards-page-navigation-list-item-link-icon"

    if onAddTag?
      t.li '.boards-page-navigation-list-item', ->
        t.b onAddTag, class: 'boards-page-navigation-list-item-link mod-quiet', ->
          t.format 'create-tag'

    return

module.exports = class extends React.Component
  displayName: 'OrganizationBoardsFilterComponent'
  render: t.renderable ->
    { filter, sorts, tags, onFilterChange, onAddTag, showOtherPrivateBoards, canShowOtherPrivateBoards, toggleOtherPrivateBoards } = @props

    t.div '.boards-page-navigation', ->
      t.input '.boards-page-navigation-input',
        type: 'text'
        placeholder: t.l 'search-for-boards'
        value: filter
        onChange: (e) ->
          onFilterChange(e.target.value)

      renderList(sorts, t.l 'sort')

      if tags.length
        renderList(tags, t.l('filter-by-tag'), { hasCloseableItems: true, onAddTag })
      else
        t.p '.quiet.boards-page-navigation-explainer', ->
          t.format 'tags-explanation'

        t.b onAddTag, class: 'quiet-button', ->
          t.format 'create-tag'

      if canShowOtherPrivateBoards
        t.ul '.boards-page-navigation-list', ->
          t.li '.boards-page-navigation-list-header', ->
            t.format 'visibility'

          t.li '.boards-page-navigation-list-item', ->

            classes =
              'boards-page-navigation-list-item-link': true
              'mod-closeable': true
              'is-active': showOtherPrivateBoards

            t.b toggleOtherPrivateBoards, class: t.classify(classes), ->
              t.format 'show other private boards'
              if showOtherPrivateBoards
                t.icon "close", class: "boards-page-navigation-list-item-link-icon"

          return



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-boards-filter-component.coffee